import classNames from "classnames";
import { IPricingCard } from "./types";

export const PricingCard = ({
  active,
  header,
  onClick,
  id,
  dataQa,
  children,
  customClass,
}: IPricingCard) => {
  const classes = classNames(
    "u-box u-box--small u-shadow-small u-flex--space-between u-flex-column plan-box",
    {
      "plan-box--selected": active,
      [`plan-box--${customClass}`]: customClass,
    }
  );

  const renderHeader = () => {
    if (!header) return null;

    return (
      <div className="plan-box__header">
        <h4>{header}</h4>
      </div>
    );
  };

  const onClickHandler = () => onClick(id);

  return (
    <div
      className={classes}
      onClick={onClickHandler}
      data-qa={dataQa}>
      {renderHeader()}
      {children}
    </div>
  );
};
